<script lang="ts">
    import { spaLink, spaNavigate } from "../../../actions"
    import { registerCustomer } from "../../../functions/CommerceAPIs/bigCommerce/customer"
    import { newNotification } from "../../../store"
    import Input from "../blocks/form/Input.svelte"
    import AddressForm from "./AddressForm.svelte"
    import {
        appendErrorMessage,
        checkPassword,
        createEmptyAddress,
        onChange,
        validateAddress,
        validateEmail,
        validateField,
    } from "./helper"

    const registerDetails: {
        email: string
        password: string
        newsletter: boolean
        dataProtection: boolean
        address: BigCommerceAddress
    } = {
        email: "",
        password: "",
        newsletter: false,
        dataProtection: false,
        address: createEmptyAddress(),
    }

    function submitUser() {
        const validations = [
            { id: "email", value: registerDetails.email, validator: validateEmail },
            { id: "password", value: registerDetails.password, validator: checkPassword },
        ]
        let isValid = validateAddress(registerDetails.address)

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }

        if (!registerDetails.dataProtection) {
            const element = document.getElementById("data") as HTMLInputElement
            element.focus()
            element.classList.add("error")
            const container = document.getElementById("dataProtection") as HTMLDivElement
            appendErrorMessage(container, "Bitte akzeptiere die Datenschutzbestimmungen", container)
            isValid = false
        }

        if (isValid) {
            registerCustomer({
                firstName: registerDetails.address.first_name,
                lastName: registerDetails.address.last_name,
                phone: registerDetails.address.phone,
                address: {
                    address1: registerDetails.address.address1,
                    address2: registerDetails.address.address2,
                    city: registerDetails.address.city,
                    postalCode: registerDetails.address.postal_code,
                    stateOrProvince: registerDetails.address.state_or_province,
                    countryCode: registerDetails.address.country_code,
                    firstName: registerDetails.address.first_name,
                    lastName: registerDetails.address.last_name,
                    phone: registerDetails.address.phone,
                },
                email: registerDetails.email,
                password: registerDetails.password,
            })
                .then(() => {
                    newNotification({
                        html: "Account wurde erfolgreich erstellt. Bitte melde dich nun an!",
                        class: "success",
                    })
                    spaNavigate("/profile/login")
                })
                .catch((error) => {
                    newNotification({ html: "Ein Fehler ist aufgetreten.", class: "error" })
                })
        }
    }
</script>

<section class="small-wrapper">
    <form
        class="register"
        on:submit|preventDefault|stopPropagation="{submitUser}"
    >
        <h2>Erstelle einen Account</h2>
        <div class="content">
            <section class="details">
                <Input
                    placeholder="E-Mail*"
                    id="email"
                    onChange="{onChange}"
                    bind:value="{registerDetails.email}"
                />
                <Input
                    placeholder="Passwort*"
                    id="password"
                    onChange="{onChange}"
                    bind:value="{registerDetails.password}"
                />
            </section>
            <section class="address">
                <AddressForm bind:address="{registerDetails.address}" />
            </section>

            <section class="newsletter">
                <div>
                    <Input
                        type="checkbox"
                        classList="checkit"
                        id="newsletter"
                        onChange="{onChange}"
                        bind:value="{registerDetails.newsletter}"
                    />
                </div>
                <p>
                    Abonniere unseren Newsletter, um die neuesten Produktinformationen, exklusive Eventeinladungen und
                    inspirierende Geschichten unserer Athlet*innen zu erhalten. Mehr erfahren.
                </p>
            </section>

            <section
                class="dataProtection"
                id="dataProtection"
            >
                <div
                    class="container"
                    id="dataProtectionContainer"
                >
                    <div>
                        <Input
                            type="checkbox"
                            id="data"
                            classList="checkit"
                            onChange="{(e) => {
                                onChange(e)
                                const dP = document.getElementById('dataProtection')
                                const dPE = dP?.querySelector('.error-message')
                                if (dPE) {
                                    dP?.removeChild(dPE)
                                }
                            }}"
                            bind:value="{registerDetails.dataProtection}"
                        />
                    </div>
                    <p>
                        Ich habe die <a
                            use:spaLink
                            href="/datenschutz">Datenschutzbestimmungen</a
                        > gelesen und akzeptiere sie.
                    </p>
                </div>
            </section>
        </div>
        <section class="submit">
            <button
                type="submit"
                class="cta primary">Registrieren</button
            >
        </section>
    </form>
</section>

<style lang="less">
    .small-wrapper {
        form {
            padding: 2.4rem 0rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 2.4rem;
            h2 {
                color: var(--text-invers-100);
            }
            .content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                gap: 1.2rem;
                .details {
                    display: flex;
                    gap: 1.2rem;
                    width: 100%;
                    input {
                    }
                }
                .address {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 1.2rem;
                }
                .newsletter {
                    display: flex;
                    gap: 1.2rem;
                    width: 100%;
                    align-items: center;
                }
                .dataProtection {
                    display: flex;
                    flex-direction: column;
                    gap: 0.6rem;
                    width: 100%;
                    .container {
                        display: flex;
                        gap: 1.2rem;
                        position: relative;
                        width: 100%;
                        align-items: center;
                    }
                }
            }
            .submit {
                display: flex;
                justify-content: flex-start;
                width: 100%;
            }
        }
    }
</style>
